import React from 'react';

import { Modal } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

import './style.scss';

/**
 *
 * @param {Boolean} visible - for Modal visibilty
 */

export function OverlayLoading({ visible = false }) {
  return (
    <Modal
      className="pd-overlay-loading"
      centered
      closable={false}
      footer={false}
      open={visible}>
      <div className="pd-align-center">
        <LoadingOutlined spin />
      </div>
    </Modal>
  );
}
